import React from 'react'
import LtBanner from '../assets/images/homepage/the-etho-homepage-1.jpg'
import RtBanner from '../assets/images/homepage/the-etho-homepage-curated-1.jpg'
import LtCurated from '../assets/images/homepage/curated-hp-2.jpg'
import RtCurated from '../assets/images/homepage/the-etho-homepage-curated-2.jpeg'

function Home() {
	return (
		<div className='main-container'>
			<div className='main-container'>
				<section id='home-hero' className='height-60 no-padding'>
					<div className='container'>
						<div className='row justify-content-center'>
							<div
								className='col-12 col-lg-6 text-center'
								style={{
									alignItems: 'center',
									backgroundImage: `url(${LtBanner})`,
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									display: 'flex',
									flexDirection: 'column',
									height: '100%',
									justifyContent: 'center'
								}}>
								<h1>The Etho</h1>
								<p className=''>
									Behind every great brand is a great woman:
									Ours is Mother Earth. An online marketplace
									making sustainable living easy.
								</p>
								<a
									className='btn btn--primary box-shadow'
									href='/'>
									<span className='btn__text'>Shop Now</span>
								</a>
							</div>
							<div
								className='col-12 col-lg-6 text-center'
								style={{
									alignItems: 'center',
									backgroundImage: `url(${RtBanner})`,
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									display: 'flex',
									flexDirection: 'column',
									height: '100%',
									justifyContent: 'center'
								}}>
								<h1>The Curated</h1>
								<p className=''>
									Welcome to our curated space where you can
									shop brands by women for women.
								</p>
								<a
									className='btn btn--primary box-shadow'
									href='http://www.alegreea.com/'
									rel='noopener noreferrer'
									target='_blank'>
									<span className='btn__text'>Shop Now</span>
								</a>
							</div>
						</div>
					</div>
				</section>
				<section id='process__section' className='hidden-xs'>
					<div className='container'>
						<div className='row'>
							<div className='col-md-4 text-center'>
								<h2 className=' light watermark-text'>01</h2>
								<h3 className=''>
									Sustainable and
									<br /> Ethical Brands
								</h3>
							</div>
							<div className='col-md-4 text-center'>
								<h2 className=' light watermark-text'>02</h2>
								<h3 className=''>
									Hassle-Free
									<br /> Shipping
								</h3>
							</div>
							<div className='col-md-4 text-center'>
								<h2 className=' light watermark-text'>03</h2>
								<h3 className=''>
									Shop brands
									<br /> by Women
								</h3>
							</div>
						</div>
					</div>
				</section>
				<section id='home-category__section' className='pt-0'>
					<div className='container'>
						<div className='row'>
							<div className='col-12 text-center'>
								<h4 className='light'>Shop By</h4>
								<h2 className=''>Category</h2>
							</div>
							<div className='col-12'>
								<div className='scrolling-wrapper'>
									<a
										href='/category'
										id='category__women'
										className='card'
										draggable='false'>
										<div className='card__body'>
											<h3 className=' '>Women</h3>
										</div>
									</a>
									<a
										href='/category'
										id='category__men'
										className='card'
										draggable='false'>
										<div className='card__body'>
											<h3 className=' '>Men</h3>
										</div>
									</a>
									<a
										href='/category'
										id='category__kids'
										className='card'
										draggable='false'>
										<div className='card__body'>
											<h3 className=' '>Kids</h3>
										</div>
									</a>
									<a
										href='/category'
										id='category__beauty'
										className='card'
										draggable='false'>
										<div className='card__body'>
											<h3 className=' '>Beauty</h3>
										</div>
									</a>
									<a
										href='/category'
										id='category__home-goods'
										className='card'
										draggable='false'>
										<div className='card__body'>
											<h3 className=' '>Home Goods</h3>
										</div>
									</a>
									<a
										href='/category'
										id='category__lifestyle'
										className='card'
										draggable='false'>
										<div className='card__body'>
											<h3 className=' '>Lifestyle</h3>
										</div>
									</a>
									<a
										href='/category'
										id='category__grocery'
										className='card'
										draggable='false'>
										<div className='card__body'>
											<h3 className=' '>Grocery</h3>
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
				</section>

				<section id='curated__section' className='pt-0'>
					<div className='container'>
						<div className='row'>
							<div className='col-12 text-center'>
								<h2 className=' '>Shop The Curated</h2>
								<h4>
									A curated selection of premium brands by
									women for women.
								</h4>
							</div>
							<div className='col-md-6'>
								<div className='curated__image-container'>
									<img
										src={LtCurated}
										alt='Handmade linen from The Curated'
									/>
								</div>
							</div>
							<div className='col-md-6 align-self-center'>
								<div className='curated__image-container'>
									<img
										src={RtCurated}
										alt='The maker of the handmade linen to the left'
									/>
								</div>
							</div>
							<div className='col-12 text-center'>
								<a
									href='/landing-page'
									className='btn btn--primary btn--lg'
									style={{
										width: '100%',
										textAlign: 'center'
									}}>
									<span className='btn__text'>
										Check Out&nbsp;
										<span className='semi-bold'>
											The Curated!
										</span>
										&nbsp;Click Here to Learn More
									</span>
								</a>
							</div>
						</div>
					</div>
				</section>

				<section id='gfc__section' className='no-padding'>
					<div className='container'>
						<div className='row'>
							<div className='col-md-6' />
							<div className='col-md-6'>
								<h4 className='light'>The Etho Story</h4>
								<h2 className=''>
									Supporting sustainable and ethical brands
									around the world.
								</h2>
								<p className=''>
									Find out what makes The Etho the place to be
									and how we&apos;re converting consumers to a
									sustainable lifestyle.
								</p>
								<a
									href='/about-us/our-story'
									className='btn btn--primary'>
									<span className='btn__text'>
										Read Our Story
									</span>
								</a>
							</div>
						</div>
					</div>
				</section>

				<section id='featured-artisan__section'>
					<div className='container'>
						<div className='row'>
							<div
								className='col-md-5'
								style={{ marginBottom: '3.2rem' }}>
								<div className='featured-image__container'>
									<img
										src='https://ignitedlocal.s3.us-east-2.amazonaws.com/The+Etho/home__featured-main.jpg'
										alt='placeholder'
										className='main-image'
									/>
									<img
										src='https://ignitedlocal.s3.us-east-2.amazonaws.com/The+Etho/home__featured-sub.jpg'
										alt='placeholder'
										className='sub-image'
									/>
								</div>
							</div>
							<div className='col-md-7 align-self-center'>
								<h4 className='light'>Featured Artisan</h4>
								<h2 className=' '>Wolven Threads</h2>
								<h3 className='light'>
									Kiran Jade &amp; Will Ryan
								</h3>
								<p>
									At Wolven, our fabric patterns are inspired
									by sacred geometry found all around us in
									nature. From beautiful cacti tthreao
									magnificent forests, nature grows
									spectacular intoxicating patterns. The
									vibrant colors of our garments are inspired
									by the colors of Indian art, celebration and
									the roots of yoga. Each fabric pattern at
									Wolven is created in-house by designers
									Kiran Jade and Will Ryan. Our garments are
									wild and —just like you.
								</p>
								<a
									href='/makers/wolven-threads'
									className='btn'>
									<span className='btn__text'>
										View Maker Products
									</span>
								</a>
							</div>
						</div>
					</div>
				</section>
				{/* <section className='bg--secondary'>
					<div className='container'>
						<div className='row justify-content-center'>
							<div className='col-md-8 col-12'>
								<h4 className='text-center'>
									Sign Up for early access, special offers,
									Lorem ipsum dolor, sit amet consectetur
									adipisicing elit. Libero soluta aut
									voluptatem magnam, at vero.
								</h4>
								<form action='#' method='post'>
									<div className='row align-items-end'>
										<div className='form-group col-md-8 col-12'>
											<label htmlFor='newsletterEmail'>
												Email Address
											</label>
											<input
												type='email'
												name='newsletterEmail'
												id='newsletterEmail'
												placeholder='Your Email'
											/>
										</div>
										<div className='form-group col-md-4 col-12'>
											<button
												type='submit'
												className='btn'>
												<span className='btn__text'>
													Sign Up for Newsletters
												</span>
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</section> */}
			</div>
		</div>
	)
}

export default Home
